(() => {
  'use strict';
  const categories = ['grillz', 'belts', 'pants-chains', 'pendants', 'rings', 'chains'];
  const isGift = item => Boolean(item.properties?._rollie_gift);
  const cents = value => Math.round(Number(value) * 100);
  function categoryFor(item, catalogs) {
    return categories.find(category => (catalogs[category] || []).some(p => Number(p.id) === Number(item.product_id))) || null;
  }
  function eligibleVariants(product, priceLimit = Infinity) {
    return product.variants.filter(v => v.available && cents(v.price) > 0 && cents(v.price) < 5000 && cents(v.price) <= priceLimit);
  }
  function cheapestProducts(products, priceLimit = Infinity) {
    return products.map(product => ({product, variants: eligibleVariants(product, priceLimit).sort((a,b) => cents(a.price)-cents(b.price))})).filter(entry => entry.variants.length).sort((a,b) => cents(a.variants[0].price)-cents(b.variants[0].price) || Number(a.product.id)-Number(b.product.id)).slice(0,12);
  }
  function discountSummary(cart) {
    const lines = (cart?.items || []).map(item => {
      const amount = (item.line_level_discount_allocations || []).reduce((total, allocation) => total + (/^buy\s+[123]\s+get\s+[123]\s+free$/i.test(allocation.discount_application?.title || '') ? Number(allocation.amount) || 0 : 0), 0);
      return {item, amount, quantity: item.original_price > 0 ? Math.min(item.quantity, Math.floor(amount / item.original_price)) : 0};
    }).filter(line => line.quantity > 0);
    return {lines, quantity: lines.reduce((total,line) => total + line.quantity,0), amount: lines.reduce((total,line) => total + line.amount,0)};
  }
  function state(cart, catalogs) {
    const paid = (cart?.items || []).filter(i => !isGift(i) && i.original_price > 0 && categoryFor(i, catalogs));
    const slots = [];
    [...paid].reverse().forEach(item => {
      const category = categoryFor(item, catalogs);
      for (let n = 0; n < item.quantity && slots.length < 3; n++) slots.push(category);
    });
    const remaining = [...slots], updates = {}, retained = [];
    for (const item of (cart?.items || []).filter(isGift)) {
      const category = item.properties._rollie_gift;
      const product = (catalogs[category] || []).find(p => Number(p.id) === Number(item.product_id));
      const valid = item.properties._rollie_offer === 'bogo-v1' && product && eligibleVariants(product).some(v => Number(v.id) === Number(item.variant_id));
      let allowed = valid ? Math.min(item.quantity, remaining.filter(c => c === category).length) : 0;
      for (let n = 0; n < allowed; n++) remaining.splice(remaining.indexOf(category), 1);
      if (allowed !== item.quantity) updates[item.key] = allowed;
      if (allowed) retained.push({item, quantity: allowed});
    }
    const discount = discountSummary(cart);
    if (!Object.keys(updates).length) {
      let covered = discount.quantity;
      for (const entry of retained) {
        const allowed = Math.min(entry.quantity, covered);
        covered -= allowed;
        if (allowed < entry.quantity) {
          updates[entry.item.key] = allowed;
          for (let n = allowed; n < entry.quantity; n++) remaining.push(entry.item.properties._rollie_gift);
          entry.quantity = allowed;
        }
      }
    }
    return {slots, remaining, updates, retained, discount, count: slots.length, giftCount: retained.reduce((n, i) => n + i.quantity, 0)};
  }
  globalThis.RollieBogo = {categories, isGift, cents, categoryFor, eligibleVariants, cheapestProducts, discountSummary, state};
})();
